import ClearIcon from '@mui/icons-material/Clear';
import { Box, Chip } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TagStyle } from '../../yoda-ui/components/Form/SelectYoda/MultiSelectYoda/MultiSelectYoda.styles';
import AdminDashboardFormContainer from '../AdminDashboardFormContainer/AdminDashboardFormContainer';
import ClearAllIcon from '../Icons/ClearAllIcon';
import { AdminDashboardFiltersPropsType, FilterKey } from './AdminDashboardFilters.types';
import {
  adminDashboardFiltersForm,
  adminDashboardFiltersTitle,
  adminDashboardSelectedTags, resetButtonStyle,
} from 'components/AdminDashboardFilters/AdminDashboardFilters.style';
import { FormLayoutContainer } from 'components/FormLayout';
import DateRangePicker from 'yoda-ui/components/Form/DateRangePicker';
import MultiSelectYoda from 'yoda-ui/components/Form/SelectYoda/MultiSelectYoda';

const AdminDashboardFilters: FC<AdminDashboardFiltersPropsType> = ({
  adminDashboardFiltersConfig,
  providerFields,
  exportDataButtonConfig,
  exportChartsButtonConfig,
  handleSearchValueOfUserFilters,
  selectedFilters,
  handleFilterChange,
  handleRemoveChip,
  hasSelectedFilters,
  handleReset,
}) => {
  const { t } = useTranslation();

  return (
    <AdminDashboardFormContainer
      providerFields={ providerFields }
      exportDataButtonConfig={ exportDataButtonConfig }
      exportChartsButtonConfig={ exportChartsButtonConfig }
    >
      <Box sx={ adminDashboardFiltersTitle }>{ t('maya_admin_dashboard_filter_title') }</Box>

      <FormLayoutContainer sx={ adminDashboardFiltersForm }>
        <MultiSelectYoda
          { ...adminDashboardFiltersConfig.countries }
          controlledValue={ selectedFilters.countries }
          onSelectedChange={ (options) => handleFilterChange('countries', options) }
        />
        <MultiSelectYoda
          { ...adminDashboardFiltersConfig.therapeuticArea }
          controlledValue={ selectedFilters.therapeuticArea }
          onSelectedChange={ (options) => handleFilterChange('therapeuticArea', options) }
        />
        <MultiSelectYoda
          { ...adminDashboardFiltersConfig.product }
          disabled={ adminDashboardFiltersConfig.product.disabled }
          controlledValue={ selectedFilters.product }
          onSelectedChange={ (options) => handleFilterChange('product', options) }
        />
        <MultiSelectYoda
          { ...adminDashboardFiltersConfig.cepFunction }
          controlledValue={ selectedFilters.cepFunction }
          onSelectedChange={ (options) => handleFilterChange('cepFunction', options) }
        />
        <MultiSelectYoda
          { ...adminDashboardFiltersConfig.cepStatus }
          controlledValue={ selectedFilters.cepStatus }
          onSelectedChange={ (options) => handleFilterChange('cepStatus', options) }
        />
        <DateRangePicker
          { ...adminDashboardFiltersConfig.date }
          onChange={ handleSearchValueOfUserFilters }
        />
      </FormLayoutContainer>

      <Box sx={ adminDashboardSelectedTags }>
        {
          Object.entries(selectedFilters).map(([key, options]) => options.map((option) => (
            <Chip
              key={ option.id }
              label={ option.label }
              sx={ TagStyle }
              onDelete={ () => handleRemoveChip(key as FilterKey, option.id) }
              deleteIcon={ <ClearIcon /> }
            />
          )))
        }
        {
          hasSelectedFilters && (
            <Box onClick={ handleReset } sx={ resetButtonStyle }>
              <ClearAllIcon />
              { t('actions_reset_label') }
            </Box>
          )
        }
      </Box>
    </AdminDashboardFormContainer>
  );
};

export default AdminDashboardFilters;
